import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

interface NavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

export function NavigationButtons({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  onSubmit,
  isSubmitting = false,
}: NavigationButtonsProps) {
  const { t } = useLanguage();
  const showBack = currentStep > 1;
  const showNext = currentStep < totalSteps;
  const showSubmit = currentStep === totalSteps;

  return (
    <div className="flex justify-between mt-10 pt-6 border-t border-slate-200">
      {showBack && (
        <button
          type="button"
          onClick={onBack}
          className="px-6 py-3 bg-white border border-slate-300 text-[#1D314D] font-semibold rounded-lg hover:bg-slate-50 transition duration-150"
        >
          {t('broker_registration.navigation.previous')}
        </button>
      )}

      {showNext && (
        <button
          type="button"
          onClick={onNext}
          className="px-6 py-3 bg-[#CEAB65] text-white font-semibold rounded-lg hover:bg-[#b99a58] transition duration-150 ml-auto"
        >
          {t('broker_registration.navigation.next')}
        </button>
      )}

      {showSubmit && (
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="px-6 py-3 bg-[#1D314D] text-white font-semibold rounded-lg hover:bg-[#2E4663] transition duration-150 ml-auto disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? t('broker_registration.navigation.submitting') : t('broker_registration.navigation.submit')}
        </button>
      )}
    </div>
  );
}
